import DOMPurify from "dompurify";

export default function SafeHtml({ html, className = "" }) {
  const clean = DOMPurify.sanitize(html || "", {
    ALLOWED_TAGS: ["p", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "h1", "h2", "h3", "h4", "blockquote", "code", "pre", "a"],
    ALLOWED_ATTR: ["href", "target", "rel"],
  });
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
